import { Icon } from '@hevoio/hevo-ui-toolkit';
import { SVGIconComponent } from '@hevoio/hevo-ui-toolkit/app/icon/Icon';
import React, { ReactNode } from 'react';
import useAnalyticsTracker from '../../../../analytics/hooks/useAnalyticsTracker';
import styles from './AppbarItemWithMenu.module.scss';

export interface AppbarMenuItemProps {
  icon?: string;
  SVGIcon?: SVGIconComponent;
  children: ReactNode;
  trackingEvent: string;
}


export function AppbarMenuItem({
  icon,
  SVGIcon,
  children,
  trackingEvent,
  onClick
}: AppbarMenuItemProps & {
  onClick?: Function;
}) {
  const { eventTrack } = useAnalyticsTracker();

  return (
    <button
      type='button'
      className={styles.appbarMenuItem}
      onClick={() => {
        eventTrack({ action: trackingEvent });

        if (typeof onClick === 'function') {
          onClick();
        }
      }}
    >
      <Icon icon={icon} SVGIcon={SVGIcon} size={3} className='mr-2' />
      {children}
    </button>
  );
}
